import { map, mapKV } from "./map";
import { allVrTypes } from "./vrTypes"

export const vrTypesToString = vrTypes => {
  let vrTypesLabel = "";
  let vrTypesObject = {};
  allVrTypes.map(o => vrTypesObject[o.value] = o.label);
  if (vrTypes)
    vrTypes.map(s => (vrTypesLabel += vrTypesLabel.length > 0 ? ", " + vrTypesObject[s] : vrTypesObject[s]));
  return vrTypesLabel;
};

export const extractCategories = allApps => {
  let allCategories = [];

  // map(allApps, ({ categories }) =>
  //   categories.forEach(e => {
  //     const newCategory = { value: e, label: e };
  //     if (!allCategories.find(s => s.value === e) && e !== "System")
  //       allCategories.push(newCategory);
  //   })
  // );

  let staticCategories = ["Game", "Video", "Education", "Relaxation", "Experience", "Tool", "Demo"];
  staticCategories.forEach(str => {
    const newCategory = { value: str, label: str };
    allCategories.push(newCategory);
  });

  return allCategories;
};


export const mergeGlobalsAndOrgApps = ({ orgApps, globalApps }) => {
  let allApps = { ...orgApps };

  let orgAppsMap = {};
  map(orgApps, ({ packageName }) => {
    orgAppsMap[packageName] = true;
  });

  mapKV(globalApps, (id, app) => {
    const { packageName } = app;
    if (!orgAppsMap[packageName]) allApps[id] = (app);
  });

  return allApps;
};
